class bar_column extends HTMLElement {
    connectedCallback() {
        this.innerHTML = `
<li class="bar__column" data-year="year">
        <span class="bar">
            <span class="bar__value" value="value"></span>
        </span>
    </li>`;
        this.querySelector('.bar__column').setAttribute("data-year", this.getAttribute('data-year'));
        this.querySelector('.bar__value').setAttribute("value", this.getAttribute('value'));

    }
}

window.customElements.define('bar-column', bar_column);
